// Branding centralizzato. Versione pubblica non ufficiale (progetto di test indipendente).
export const OFFICIAL_BRANDING = false;

const TEST = {
  appName: "Dashboard Test Soccorso",
  shortName: "Dashboard Test",
  reportTitle: "Dashboard Test Soccorso",
  reportSubtitle: "Report soccorso - progetto di test indipendente",
  logo: null,
  logoAlt: "",
  emergencyNumber: null,
  notificationTitle: "Nuovo SOS \u2014 Dashboard Test",
  banner: "Progetto di test indipendente, non affiliato ad alcun ente istituzionale o servizio di emergenza",
};

export const BRAND = TEST;
